import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root'
})
export class TiposOperacionesService {

  constructor(public http: HttpClient, private env: EnvService) { }

  headers = new HttpHeaders().set('Content-Type', 'application/json');

  crear(body): Observable<any> {
    return this.http.post(`${this.env.URL_API}/tipos_operaciones`, body);
  }
  actualizar(body): Observable<any> {
    return this.http.put(`${this.env.URL_API}/tipos_operaciones/${body.id_tipos_operaciones}`, body);
  }
  obtenerTodos(): Observable<any> {
    return this.http.get(`${this.env.URL_API}/tipos_operaciones`, { headers: this.headers });
  }
  obtenerId(id): Observable<any> {
    return this.http.get(`${this.env.URL_API}/tipos_operaciones/${id}`);
  }
  eliminar(id): Observable<any> {
    const body = { body: { id_usuarios_creador: sessionStorage.getItem('id_usuario') }, headers: this.headers };
    return this.http.delete(`${this.env.URL_API}/tipos_operaciones/${id}`, body);
  }
}
